import React, { useEffect } from 'react';
import { Button, Flex, Space, Typography } from 'antd';
import { FieldArray, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';

import { SuggestionDeleteButton } from '../components/Suggestions/SuggestionDeleteButton';
import { SuggestionAddButton } from '../components/Suggestions/SuggestionAddButton';
import { useLazyReadSuggestionsQuery } from '../service/ai';
import { useSuggestions } from '../hooks/useSuggestions';
import * as S from '../styles/Common.styles';
import { addTooltip, removeTooltip } from '../store/suggestionsSlice';
import { SuggestionField } from '../components/Suggestions/SuggestonField';
import { MAX_SUGGESTIONS } from '../utils/suggestionOptions';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

const { Text } = Typography;

export const SuggestionsContainer = () => {
    const current = useAppSelector(selectShopCurrent);
    const { tooltips, submit } = useSuggestions();
    const dispatch = useDispatch();

    const [getSuggestions] = useLazyReadSuggestionsQuery();

    useEffect(() => {
        if (current.id) {
            getSuggestions(current.id);
        }
    }, [current.id]);

    const canAdd = tooltips.length < MAX_SUGGESTIONS;

    return (
        <Formik
            enableReinitialize
            initialValues={{ tooltips }}
            onSubmit={values => {
                void submit(values.tooltips);
            }}
        >
            {({ values }) => (
                <Form>
                    <Flex
                        style={{
                            marginBottom: 24,
                        }}
                        vertical
                        gap={8}
                    >
                        <S.Title level={4}>Настроить вопросы</S.Title>
                        <Text>
                            Эта функция позволяет создавать кнопки в чате с
                            ботом, которые помогут покупателям быстро задавать
                            популярные вопросы. Максимальное количество вопросов{' '}
                            {MAX_SUGGESTIONS}.
                        </Text>
                    </Flex>
                    <Flex gap={24} vertical>
                        <FieldArray name='tooltips'>
                            {arrayHelpers => (
                                <>
                                    {values.tooltips.map((item, index) => (
                                        <Flex
                                            key={index}
                                            vertical={false}
                                            gap={16}
                                            align={'flex-end'}
                                        >
                                            <SuggestionField
                                                name={`tooltips[${index}].title`}
                                                index={index}
                                                fieldKey='title'
                                                maxLength={15}
                                                placeholder='Название вопроса'
                                                value={item.title}
                                            />
                                            <SuggestionField
                                                name={`tooltips[${index}].text`}
                                                index={index}
                                                fieldKey='text'
                                                maxLength={300}
                                                placeholder='Текст вопроса'
                                                value={item.text}
                                            />

                                            <SuggestionDeleteButton
                                                onClick={() => {
                                                    dispatch(
                                                        removeTooltip(index)
                                                    );
                                                }}
                                            />
                                        </Flex>
                                    ))}

                                    {canAdd && (
                                        <SuggestionAddButton
                                            onClick={() => {
                                                arrayHelpers.push({
                                                    title: '',
                                                    text: '',
                                                });
                                                dispatch(addTooltip());
                                            }}
                                        />
                                    )}
                                </>
                            )}
                        </FieldArray>

                        <Space>
                            <Button type='primary' htmlType='submit'>
                                Сохранить
                            </Button>
                        </Space>
                    </Flex>
                </Form>
            )}
        </Formik>
    );
};
